<script lang="ts">
	import type { Hub } from '$lib/api/rpc';
	import BreakPoint from '$lib/components/BreakPoint/BreakPoint.svelte';
	import HeaderBarIcons from '$lib/components/headerBar/HeaderBarIcons.svelte';
	import { scrollY } from '$lib/stores/resizeStore';
	import type { Writable } from 'svelte/store';
	import type { Device } from '$lib/types/Device';

	export let device: Device;
	export let hub: Writable<Hub>;
	export let forDesignPage = false;

	$: alwaysVisible =
		$hub.theme.headerBarAlwaysVisible || $hub.theme.coverHideCover || device == 'mobile';
	$: scrollLimit = $hub?.theme?.coverHideCover || alwaysVisible ? 0 : 430; //The cover height is 480px - the headerBar height 50px = 430px.
	$: isOverScrollLimit = $scrollY >= scrollLimit;
	$: logoTransform = `translate(0,${
		alwaysVisible ? 0 : $scrollY < 1000 ? -($scrollY / 10 - 100) : 0
	}px)`;
</script>

<div
	class="header"
	class:coloredBackground={isOverScrollLimit}
	style:--headerBackgroundColor={$hub.theme.headerBackgroundColor}>
	{#if device == 'mobile' && forDesignPage}
		<div class="headerContainer">
			<!-- <Icon icon="menu" clickable size={'24'} color={$hub.theme.headerIconColor} /> -->
			{#if $hub.theme.headerLogoImage}
				<div
					class="logoContainer"
					class:isCentered={$hub.theme.headerCentreLogo && device != 'mobile'}
					class:isMobile={true}>
					<img
						class="logo"
						class:visible={true}
						src={$hub.theme.headerLogoImage}
						style:--logoTransform={logoTransform}
						alt="logo" />
				</div>
			{/if}
			<HeaderBarIcons {hub} />
		</div>
	{:else}
		<BreakPoint>
			<div class="headerContainer">
				<!-- <Icon icon="menu" clickable size={'24'} color={$hub.theme.headerIconColor} /> -->
				{#if $hub.theme.headerLogoImage}
					<div
						class="logoContainer"
						class:isCentered={$hub.theme.headerCentreLogo && device != 'mobile'}>
						<img
							class="logo"
							class:visible={isOverScrollLimit}
							src={$hub.theme.headerLogoImage}
							style:--logoTransform={logoTransform}
							alt="logo" />
					</div>
				{/if}
				<HeaderBarIcons {hub} />
			</div>
		</BreakPoint>
	{/if}
</div>
{#if alwaysVisible}
	<div style="block-size: 50px" />
	<!-- headerBar has 50px height -->
{/if}

<style>
	.header {
		position: fixed;
		z-index: var(--z-index-Header);
		block-size: var(--navbarHeight);
		inline-size: 100%;
		inset-block-start: 0;
	}

	.coloredBackground {
		background-color: var(--headerBackgroundColor);
	}

	@media screen and (max-width: 575px) {
		.header {
			background-color: var(--headerBackgroundColor);
		}
	}

	.headerContainer {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		block-size: 100%;
	}

	.logo {
		visibility: hidden;
		block-size: 100%;
		transform: var(--logoTransform);
	}

	.logoContainer {
		display: flex;
		justify-content: flex-start;
		block-size: 100%;
		inline-size: 100vw;
		margin-inline-start: 30px;
		overflow: hidden;
	}

	.isCentered {
		justify-content: center;
		margin-inline-start: 168px;
	}

	.visible {
		visibility: visible;
	}
</style>
